export default (value?: number | string | null): number =>
  Math.round(Number(value || 0) * 100);
